import { format } from 'date-fns';

export const getRecommendedPaymentDueDateHelper = (
  today: Date,
  paymentDueDateConfig?: { offsetType: string; valueInDays?: number }
): string => {
  if (!paymentDueDateConfig) {
    return format(today, 'yyyy-MM-dd');
  }

  const { offsetType, valueInDays = 0 } = paymentDueDateConfig;

  if (offsetType === 'OFFSET') {
    const recommendedDate = new Date(today);
    recommendedDate.setDate(today.getDate() + Math.abs(valueInDays));
    return format(recommendedDate, 'yyyy-MM-dd');
  }

  if (offsetType === 'FIXED') {
    const dayOfMonth = valueInDays || 1; // Default to 1st day of the month if valueInDays is 0
    const recommendedDate = new Date(today.getFullYear(), today.getMonth(), dayOfMonth);

    // If the date has passed this month, use next month
    if (recommendedDate <= today) {
      recommendedDate.setMonth(recommendedDate.getMonth() + 1);
    }

    return format(recommendedDate, 'yyyy-MM-dd');
  }

  return format(today, 'yyyy-MM-dd');
};
